import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';
import { GetNamesOfPersonWithPivRelationRes } from '@dealstack/shared/lib/generated';
import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common';

const getPivNames = async ({
	searchQuery,
	cursor = '',
	limit = 10,
}: {
	searchQuery?: string;
	cursor?: string;
	limit?: number;
}) => {
	const response = await makeRequest<ApiV1.Response<GetNamesOfPersonWithPivRelationRes>>({
		endpoint: API_PATHS.MIP_INVESTOR_INVESTMENT_VEHICLES_NAMES_FILTERING_GET,
		method: HTTP_METHOD.GET,
		queryString: {
			search: searchQuery,
			cursor,
			limit: limit?.toString(),
		},
	});
	return response;
};

export const usePivNames = ({
	mipId,
	searchQuery,
	limit,
	enabled = true,
}: {
	mipId: string;
	searchQuery?: string;
	limit?: number;
	enabled?: boolean;
}) =>
	useInfiniteQuery({
		queryKey: [
			API_PATHS.MIP_INVESTOR_INVESTMENT_VEHICLES_NAMES_FILTERING_GET,
			{ mipId, searchQuery },
		],
		initialPageParam: '',
		queryFn: async ({ pageParam }) =>
			await getPivNames({
				searchQuery,
				cursor: pageParam,
				limit,
			}),
		getNextPageParam: (lastPage) => lastPage.payload?.nextCursor,
		placeholderData: keepPreviousData,
		enabled,
	});
